<template>
  <div class="card" ref="card">
    <ul>
      <li v-for="(item, index) in treeData" :key="index">
        <div
          class="item"
          :class="{
            'line-left': index !== 0,
            'line-right': index != treeData.length - 1,
          }"
        >
          <div
            class="item-name"
            :class="{
              'line-bottom': item.child && item.child.length > 0,
              'line-top': !treeFirst,
            }"
          >
            <div :style="{ transform: 'rotate(180deg)' }">
              {{ item.name }}
            </div>
          </div>
        </div>
        <tree-item
          v-if="item.child && item.child.length > 0"
          :tree-data="item.child"
          :is-right="isRight"
        />
      </li>
    </ul>
  </div>
</template>

<script setup>
// 获取传参
import { inject, nextTick, onMounted, ref } from "vue";

const props = defineProps({
  treeData: {
    type: Array,
    default: () => [],
  },
  treeFirst: {
    //判断是否第一个
    type: Boolean,
    default: false,
  },
  isRight: {
    type: Boolean,
    default: false,
  },
});

const height = inject("height");
const card = ref(null);

onMounted(() => {
  nextTick(() => {
    height.value = card.value.offsetWidth;
    console.log(height.value);
  });
});
</script>

<style lang="scss" scoped>
$line-length: 10px; //线长
$spacing: 10px; //间距
$extend: calc(#{$spacing} - 2px); //延长线

// 线样式
@mixin line {
  content: "";
  display: block;
  width: 3px;
  height: $line-length;
  position: absolute;
  left: 0;
  right: 0;
  margin: auto;
  background: #b7b7b7;
}

.card {
  position: relative;
  ul {
    display: flex;
    justify-content: center;
    li {
      .item {
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        &-name {
          position: relative;
          display: flex;
          justify-content: center;
          align-items: center;
          width: 40px;
          height: 140px;
          padding: 5px;
          margin: $spacing;
          background: #7a7a7a;
          color: #fff;
          div {
            writing-mode: tb-rl;
          }
          .plus {
            &:hover {
              opacity: 100%;
            }
          }
          .reduce {
            top: -5px;
            &:hover {
              opacity: 100%;
            }
          }
        }
      }
    }
  }
  // 向下的线
  .line-bottom {
    &::after {
      @include line();
      bottom: -$line-length;
    }
  }
  // 向上的线
  .line-top {
    &::before {
      @include line();
      top: -$line-length;
    }
  }
  // 向左的线
  .line-left {
    &::after {
      @include line();
      width: calc(50% + #{$spacing});
      height: 3px;
      left: calc(-50% - #{$extend});
      top: 0;
    }
  }
  // 向右的线
  .line-right {
    &::before {
      @include line();
      width: calc(50% + #{$spacing});
      height: 3px;
      right: calc(-50% - #{$extend});
      top: 0;
    }
  }
}
</style>
